import { simpleAjaxDispatch } from './http';
import qs from 'querystringify';


export function getAllActionsAndDecisions(opts) {
  const qsData = {
    ...opts,
    limit: 10,
  };
  const qsFinal = qs.stringify(qsData, true);

  return simpleAjaxDispatch(
    `/actions${qsFinal}`,
    'actionsAndDecisions',
  );
}

export function closeAction(jsonData, actionId) {
  return simpleAjaxDispatch(
    `/action_close/${actionId}`,
    'closeAction',
    {
      method: 'PATCH',
      body: JSON.stringify(jsonData),
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export function fetchActionCountByStatus(status) {
  return simpleAjaxDispatch(
    `/actions/count?status=${status}`,
    'fetchActionCountByStatus',
  );
}
